import React, { useCallback, useState } from 'react';
import { useFormikContext, useField } from 'formik';
import { filter, join, pipe, props } from 'ramda';
import PropTypes from 'prop-types';

import { ID, RECOMMENDED, REFERRAL, SUB_ORGANIZATION, FILES } from 'store/diagnoses';
import { ADDRESS, CANTON, CITY, NAME, useOrganizationActions, ZIP_CODE } from 'store/organizations';
import PaginationDropDown from 'components/PaginationDropDown';

import { DEFAULT_PARAMS } from './utils';
import OrganizationItem from './OrganizationItem';
import Documents from './Documents';
import { YesNoQuestion, Warning } from './styles';

export default function Referral({ readMode }) {
  const { setValues } = useFormikContext();
  const [{ value: referral }] = useField(`${REFERRAL}.${RECOMMENDED}`);
  const [refValue, setRefValue] = useState(referral);
  const [{ value: referralOrganization }] = useField(`${REFERRAL}.${SUB_ORGANIZATION}`);
  const { fetchCollectOrganizations } = useOrganizationActions();
  const getOrganizations = useCallback(
    (args) => fetchCollectOrganizations({ ...args, ...DEFAULT_PARAMS }),
    [fetchCollectOrganizations]
  );
  const getItemName = useCallback(
    (item) =>
      [item[NAME], pipe(props([ADDRESS, ZIP_CODE, CITY, CANTON]), filter(Boolean), join(' '))(item)].filter(Boolean).join(', '),
    []
  );

  const onChangeReferral = useCallback(
    (value) => {
      setRefValue(value);

      if (!value) {
        setValues(($) => ({
          ...$,
          [REFERRAL]: { ...$[REFERRAL], [RECOMMENDED]: false, [SUB_ORGANIZATION]: null, [FILES]: [] },
        }));
      }
    },
    [setValues]
  );
  const onChangeOrganization = useCallback(
    (org) =>
      setValues(($) => ({
        ...$,
        [REFERRAL]: {
          ...$[REFERRAL],
          [RECOMMENDED]: Boolean(org?.[ID]),
          [SUB_ORGANIZATION]: org?.[ID] ? org : null,
          [FILES]: org?.[ID] ? $[REFERRAL]?.[FILES] || [] : [],
        },
      })),
    [setValues]
  );

  return (
    <YesNoQuestion
      question="Möchten Sie den Patienten überweisen?"
      value={refValue}
      onChoose={onChangeReferral}
      readMode={readMode}
      withoutBorder
    >
      {refValue && (
        <>
          {!readMode && refValue && !referralOrganization?.[ID] && <Warning>Wählen Sie eine Klinik aus.</Warning>}
          <PaginationDropDown
            idKey={ID}
            nameKey={getItemName}
            action={getOrganizations}
            placeholder="Suchen"
            value={referralOrganization}
            onChange={onChangeOrganization}
            selectedComponent={OrganizationItem}
            disabled={readMode}
            withoutRemoving
            onlyOne
          />
          {referralOrganization?.[ID] && <Documents readMode={readMode} />}
        </>
      )}
    </YesNoQuestion>
  );
}

Referral.propTypes = { readMode: PropTypes.bool.isRequired };
